<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <employee-profile-payroll-bank-detail-container-view
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
        />
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="statutory-col"
      >
        <div class="px-10">
          <v-row>
            <v-col>
              <span class="font-16 font-calibri font-weight-bold">Statutory</span>
            </v-col>
          </v-row>

          <employee-profile-payroll-epf-detail-container-view
            :employee-uid="employeeUid"
            :is-resigned="isResigned"
          />
          <employee-profile-payroll-socso-detail-container-view
            ref="socso"
            :employee-uid="employeeUid"
            :is-resigned="isResigned"
          />
          <employee-profile-payroll-income-tax-detail-container-view
            :employee-uid="employeeUid"
            :is-resigned="isResigned"
          />
        </div>
      </v-col>

      <v-col cols="12">
        <employee-profile-payroll-payroll-company-container-view
          ref="payrollContainer"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
          @updated="$emit('updated')"
          @loaded="$emit('loaded')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollIncomeTaxDetailContainerView: () => import('@/components/hris/employee/profile/payroll/income-tax-detail/ContainerView'),
      EmployeeProfilePayrollEpfDetailContainerView: () => import('@/components/hris/employee/profile/payroll/epf-detail/ContainerView'),
      EmployeeProfilePayrollSocsoDetailContainerView: () => import('@/components/hris/employee/profile/payroll/socso-detail/ContainerView'),
      EmployeeProfilePayrollBankDetailContainerView: () => import('@/components/hris/employee/profile/payroll/bank-detail/ContainerView'),
      EmployeeProfilePayrollPayrollCompanyContainerView: () => import('@/components/hris/employee/profile/payroll/payroll-company/ContainerView'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      loadPayrolls () {
        this.$refs.payrollContainer.loadData()
      },
      loadStatutoryDetails () {
        if (this.$refs.socso) {
          this.$refs.socso.loadEmployeeSocso()
        }
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

@media (min-width: 960px) {
  .statutory-col{
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
